<div>
  <div class="text-xs font-semibold uppercase mb-1">Ticket #</div>
  {{ ticket.CaseNumber || '---' }}
</div>
<div class="type-status flex flex-row justify-between flex-grow pl-4">
  <div>
    <div class="text-xs font-semibold uppercase mb-1">Title</div>
    <div class="text-xl">
      {{
        (ticket.Subject | titlecase) ||
          (ticket.Portal_Ticket_Type__c | titlecase) ||
          '---'
      }}
    </div>
  </div>
  <!-- status-date -->
  <div>
    <div class="text-xs font-semibold uppercase text-right mb-1">Status</div>
    <div class="flex flex-col items-baseline">
      @if (ticket.IsClosed) {
        <span class="text-green-500 font-bold text-base uppercase self-end"
          >Closed</span
        >
        <div
          class="text-gray-600 text-right font-normal text-sm self-end min-w-[135px]"
        >
          closed {{ ticket.ClosedDate | date: 'h:mma' }}<br />
          {{ ticket.ClosedDate | date: 'MMM d, y' }}
        </div>
      } @else {
        <span class="text-orange-600 font-bold text-base uppercase self-end"
          >Open</span
        >
        <div
          class="text-gray-600 text-right font-normal text-sm self-end min-w-[135px]"
        >
          opened {{ ticket.CreatedDate | date: 'h:mma' }}<br />
          {{ ticket.CreatedDate | date: 'MMM d, y' }}
        </div>
      }
    </div>
  </div>
</div>
